import factory from './icon';
import Svg16x16 from './glyphs/Magnifier_16x16.svg';
import Svg24x24 from './glyphs/Magnifier_24x24.svg';

export const Search16x16 =  factory(Svg16x16, 16, 16);
export const Search24x24 =  factory(Svg24x24, 24, 24);
